var Model = require('../Model');

var ReportFolder = Object.create(Model);

ReportFolder.name = 'ReportFolder';
ReportFolder['@class'] = 'ReportFolder';
ReportFolder.url = 'reportfolder';
ReportFolder.fields = {
  parent: {
    default: null
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  }
};

module.exports = ReportFolder;
